import { Dialog, DialogContent, Divider, Typography } from '@mui/material'
import { Box } from '@mui/system'
import offline from 'assets/offline.png'

interface OfflineDialogProps {
  openDialog: boolean
}

function OfflineDialog(props: OfflineDialogProps) {
  return (
    <Dialog fullScreen open={props.openDialog}>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={offline} style={{ width: '200px', height: '200px' }} />
          <Typography variant='h1' sx={{ mt: 2 }}>
            No Internet Available!
          </Typography>
          <Typography variant='h3' sx={{ mt: 2 }}>
            Check your internet connection and try again later
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
export default OfflineDialog
